// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"3a3481a7","375":"e8ea4aa8","938":"d77c632e"}[chunkId] + ".chunk.js";
};